import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import SideMenu from './SideMenu/SideMenu';
import Timeline from './Timeline/Timeline';
import SearchBox from './SearchBox/SearchBox';
import CategoryPage from './CategoryPage/CategoryPage';
import ItemDetail from './ItemDetail/ItemDetail';
import * as api from '../../api';
import * as stats from '../../utils/Stats';
import Home from './Home/Home';
import About from './About/About';
import Tag from './Tag/Tag';
import ArchiveList from './ArchiveList/ArchiveList';
import CtHead from './CtHead/CtHead';
import { MAIN_SECTIONS, ROUTING, RESIZE_LIMITS, PATH } from '../../constants';
import {
  gridUpdate,
  widthUpdate,
  menuSwitch,
  menuOverlayUpdate,
} from '../../redux/actions';
import './App.css';
import School from './School/School';
import SchoolDetail from './SchoolDetail/SchoolDetail';
import Vysilani from './Vysilani/Vysilani';
import Map from './Map/Map';
import ToTopBtn from './ToTopBtn/ToTopBtn';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeInit: true, // for init home menu hide
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    this.categoryScroll = 0; // note - revise scroll stuff
    api.initHash();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    // init
    this.handleResize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.detailActive && !this.props.detailActive) {
      window.scrollTo(0, this.categoryScroll);
    } else if (
      prevProps.location.pathname === ROUTING.HOME &&
      this.props.location.pathname !== ROUTING.HOME
    ) {
      // on redirect from home - for home -> category swap
      window.scrollTo(0, 0);
    }
    // try track route change event
    if (this.props.location !== prevProps.location) {
      stats.trackEvent('section', this.props.location.pathname);
    }
    // try show menu
    this.checkMenu();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  // -------------------------------------------------------
  // Menu
  // -------------------------------------------------------

  checkMenu() {
    // show main menu on init and different page than home
    if (
      this.state.homeInit &&
      this.props.location.pathname !== ROUTING.HOME &&
      this.props.location.pathname.indexOf(ROUTING.DETAIL) === -1
    ) {
      this.setState({ homeInit: false });
      if (!this.props.menuVisible && !this.props.menuOverlay) {
        this.props.menuSwitchDispatch();
      }
    }
  }

  // -------------------------------------------------------
  // Scroll
  // -------------------------------------------------------

  handleScroll() {
    if (!this.props.detailActive) {
      this.categoryScroll = document.documentElement.scrollTop;
    }
  }

  // -------------------------------------------------------
  // Resize
  // -------------------------------------------------------

  handleResize() {
    const winW = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    let grid = 1;
    for (let i = 0; i < RESIZE_LIMITS.GRID.length; i += 1) {
      if (winW > RESIZE_LIMITS.GRID[i][0]) {
        grid = RESIZE_LIMITS.GRID[i][1];
        break;
      }
    }
    // try update
    if (grid !== this.props.grid) {
      // todo - is it needed?
      this.props.gridUpdate(grid);
    }

    // try menu overlay
    let overlay = false;
    if (winW < RESIZE_LIMITS.MENU_OVERLAY) {
      overlay = true;
    }
    if (overlay !== this.props.menuOverlay) {
      this.props.menuOverlayUpdate(overlay);
    }

    // try update width
    if (winW !== this.props.width) {
      // todo - is it needed?
      this.props.widthUpdate(winW);
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const {
      detailActive,
      categoryId,
      menuVisible,
      menuOverlay,
      menuSwitchDispatch,
      location,
    } = this.props;

    // try bg pattern
    let pageStyle = {};
    if (categoryId.length > 0) {
      const bgPattern = `${PATH.IMG}pattern/pattern-${categoryId}.png`;
      pageStyle = {
        backgroundImage: `url(${bgPattern})`,
        backgroundRepeat: 'repeat',
        backgroundColor: `#${MAIN_SECTIONS[categoryId].bgColor}`,
      };
    } else if (location.pathname === ROUTING.HOME) {
      pageStyle.background = 'linear-gradient(#fdfbf8 , #f9efe3 18%)';
    }

    // menu style
    pageStyle.marginLeft = !menuVisible || menuOverlay ? 0 : 220;
    pageStyle.transition = 'margin-left 0.2s';

    // wrap style - for school sheets
    // todo - revise - make easier to expand
    const wrapStyle =
      location.pathname.indexOf(ROUTING.SCHOOL_DETAIL) !== -1 ||
      location.pathname === ROUTING.HOME
        ? 'wrap-full'
        : '';

    return (
      <div>
        <div id="main-wrap" className={detailActive ? 'disabled' : ''}>
          <CtHead />
          <div id="menu-top">
            <button className="btn-menu" onClick={() => menuSwitchDispatch()}>
              <img src={`${PATH.IMG}ico/ico-menu.png`} alt="Menu" />
            </button>
            <Timeline />
            <SearchBox />
          </div>
          <SideMenu />
          <div id="app-content" style={pageStyle}>
            <div id="app-content-wrap" className={wrapStyle}>
              <Route exact path={ROUTING.HOME} component={Home} />
              <Route path={ROUTING.ABOUT} component={About} />
              <Route
                path={`${ROUTING.CATEGORY}/:categoryId`}
                component={CategoryPage}
              />
              <Route path={`${ROUTING.TAG}/:tag`} component={Tag} />
              <Route path={ROUTING.ARCHIVE_LIST} component={ArchiveList} />
              <Route path={ROUTING.SCHOOL} component={School} />
              <Route
                path={`${ROUTING.SCHOOL_DETAIL}/:sheetId/:anchor?`}
                component={SchoolDetail}
              />
              <Route path={ROUTING.VYSILANI} component={Vysilani} />
              <Route path={ROUTING.MAP} component={Map} />
            </div>
          </div>
          <ToTopBtn />
        </div>
        <Route path={`${ROUTING.DETAIL}/:detailId`} component={ItemDetail} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detailActive: state.dataDetail.active,
  categoryId: state.dataCategory.category,
  grid: state.resize.grid,
  width: state.resize.width,
  menuVisible: state.resize.menuVisible,
  menuOverlay: state.resize.menuOverlay,
});

const mapDispatchToProps = dispatch => ({
  gridUpdate: grid => dispatch(gridUpdate(grid)),
  widthUpdate: width => dispatch(widthUpdate(width)),
  menuSwitchDispatch: () => dispatch(menuSwitch()),
  menuOverlayUpdate: menuOverlay => dispatch(menuOverlayUpdate(menuOverlay)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App/App.js